import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {ErrorMessage, Field, Form, Formik} from "formik";
import * as Yup from "yup";
import {clearMessage} from "../slices/message";
import {messages} from "../i18n/messages";
import {LOCALES} from "../i18n/locales";
import {createUser} from "../services/admin.service";

const CreateUser = () => {
  const [successful, setSuccessful] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [countries, setCountries] = useState(["CAN", "USA"]);
  const [country, setCountry] = useState("CAN");


  const { message } = useSelector((state) => state.message);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(clearMessage());
  }, [dispatch]);

  const [initialValues, setInitialValues] = useState({
    firstName: "",
    lastName: "",
    email: "",
    country: country || ""
  });

  const validationSchema = Yup.object().shape({
    firstName: Yup.string().required(messages[LOCALES.ENGLISH].field_required),
    lastName: Yup.string().required(messages[LOCALES.ENGLISH].field_required),
    email: Yup.string()
      .email(messages[LOCALES.ENGLISH].invalid_email)
      .required(messages[LOCALES.ENGLISH].field_required),
  });

  const handleSelectionCountry = (event) => {
    setCountry(event.target.value);
  }

  const handleCreate = (formValue) => {
    const { firstName, lastName, email } = formValue;

    setSuccessful(false);
    setIsLoading(true);

    dispatch(createUser({ firstName, lastName, email, country }))
      .unwrap()
      .then(() => {
        setSuccessful(true);
        setIsLoading(false);
      })
      .catch(() => {
        setSuccessful(false);
        setIsLoading(false);
      });
  };

  return (
    <div className="container-fluid d-flex flex-column justify-content-center align-items-center py-5" style={{ background: 'var(--bg-gradient)', minHeight: 'calc(100vh - 76px)' }}>
      <div className="card border-0 shadow-lg" style={{ borderRadius: '24px', width: '100%', maxWidth: '500px', overflow: 'hidden' }}>
        <div className="card-body p-4 p-md-5">
          <div className="text-center mb-4">
            <div className="d-inline-flex align-items-center justify-content-center bg-primary bg-opacity-10 rounded-circle mb-3" style={{ width: '64px', height: '64px' }}>
              <i className="bi bi-person-plus text-primary fs-2"></i>
            </div>
            <h2 className="fw-bold mb-2" style={{ color: 'var(--text-dark)' }}>Create Owner</h2>
            <p className="text-danger small fw-bold mb-0">*** ONLY create OWNER user here. Client user should be created when registering a new client.</p>
          </div>
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleCreate}
        >
          <Form>
            {!successful && (
              <div className="d-flex flex-column gap-3">
                <div>
                  <label htmlFor="firstName" className="text-muted small fw-bold mb-1">First Name</label>
                  <Field name="firstName" type="input" className="form-control form-control-lg bg-light border-0" style={{ fontSize: '1rem' }} />
                  <ErrorMessage name="firstName" component="div" className="text-danger small mt-1 fw-medium" />
                </div>
                <div>
                  <label htmlFor="lastName" className="text-muted small fw-bold mb-1">Last Name</label>
                  <Field name="lastName" type="input" className="form-control form-control-lg bg-light border-0" style={{ fontSize: '1rem' }} />
                  <ErrorMessage name="lastName" component="div" className="text-danger small mt-1 fw-medium" />
                </div>
                <div>
                  <label htmlFor="email" className="text-muted small fw-bold mb-1">Email</label>
                  <Field name="email" type="email" className="form-control form-control-lg bg-light border-0" style={{ fontSize: '1rem' }} />
                  <ErrorMessage name="email" component="div" className="text-danger small mt-1 fw-medium" />
                </div>
                <div>
                  <label htmlFor="country" className="text-muted small fw-bold mb-1">Country</label>
                  <div className="dropdown">
                    <select
                        name="country"
                        value={country}
                        className="form-select form-select-lg bg-light border-0"
                        style={{ fontSize: '1rem' }}
                        onChange={(event) => {
                          handleSelectionCountry(event);
                        }}
                    >
                      {countries && countries.map((country, index) => (
                          <option key={index} value={country}>
                            {country}
                          </option>
                      ))}
                    </select>
                  </div>
                </div>
                
                <button type="submit" className="btn-premium w-100 rounded-pill py-2 mt-3" disabled={isLoading}>
                  {isLoading ? (
                      <span className="spinner-border spinner-border-sm me-2"></span>
                  ) : (
                      <i className="bi bi-person-plus-fill me-2"></i>
                  )}
                  <span className="fw-bold">Create User</span>
                </button>
              </div>
            )}
          </Form>
        </Formik>
        </div>
      </div>

      {message && (
        <div className="mt-4 w-100" style={{ maxWidth: '500px' }}>
          <div
            className={`alert ${successful ? "alert-success" : "alert-danger"} border-0 shadow-sm rounded-3 d-flex align-items-center`}
            role="alert"
          >
            <i className={`bi ${successful ? "bi-check-circle-fill" : "bi-exclamation-triangle-fill"} me-2 fs-5`}></i>
            <div>{message}</div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CreateUser;
